import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import PublisherCard from '../../components/publisherCard';
import usePublisher from '../../../store/models/publisher/usePublisher';
import * as styles from './styles';

function WhatsHot({ onSync, onShare }) {
    const { whatshotPublishers } = usePublisher();

    function renderSectionHeader() {
        return (
            <Box sx={styles.sectionHeader}>
                <Box>
                    <Box sx={styles.eyebrow}>
                        <LocalFireDepartmentIcon sx={styles.flameIcon} />
                        What's Hot!
                    </Box>
                    <Typography variant="h2" sx={styles.title}>
                        The 25 hottest publishers on ECAL{' '}
                        <Box component="span" sx={styles.gradientToday}>today</Box>
                    </Typography>
                    <Typography sx={styles.subtitle}>
                        Ranked daily based on new subscriptions, biggest improvers and 7-day momentum!
                    </Typography>
                </Box>
            </Box>
        );
    }

    function renderGrid() {
        return (
            <Box sx={styles.grid}>
                {whatshotPublishers.map((publisher) => (
                    <PublisherCard
                        key={publisher.id}
                        publisher={publisher}
                        onSync={onSync}
                        onShare={onShare}
                    />
                ))}
            </Box>
        );
    }

    return (
        <Box component="section" sx={styles.section}>
            <Container maxWidth="xl">
                {renderSectionHeader()}
                {renderGrid()}
            </Container>
        </Box>
    );
}

export default WhatsHot;
